<div class="component-container container">
	<div class="selectContainer" *ngIf='!showForm && !userPOS'>
		<form [formGroup]="businessInfo.form">
			<p class="selectionTittle">Affordable Monthly Payments.</p>
			<p class="selectSpecifications">See if you qualify—it won't affect your credit</p>
			<div class="form-row">
				<div class="form-group col-sm-6 select">
					<label for="businessType" [ngClass]="{ 'color-red': submitted && bForm.businessType.errors }">Select
						Business Type:*
						<div class="information-icon">
							<i class="fa fa-info-circle" aria-hidden="true"></i>
							<div class="tool-tip-container">
								<div class="tip-text">
									<span>If you are unsure, check</span>
									<span>your business license.</span>
								</div>
							</div>
						</div>
					</label>
					<select (change)='bussinesTypeChange($event)' formControlName="businessType" class="form-control"
						id="businessType" name="businessType"
						[ngClass]="{ 'is-invalid': submitted && bForm.businessType.errors }">
						<option *ngFor="let businessType of businessTypes" [ngValue]="businessType.code">
							{{businessType.name}}</option>
					</select>
					<div *ngIf="submitted && bForm.businessType.errors" class="invalid-feedback">
						<div *ngIf="bForm.businessType.errors.required">
							Business Type is required.
						</div>
					</div>
				</div>
			</div>
		</form>
	</div>
	<div *ngIf='showForm || userPOS'>
		<div class="clearfix form-step">
			<div class="row position-relative" *ngIf="!production">
				<button class="btn btn-primary btn-lg auto-populate"
					(click)="onCompleteInformationClick(); $event.preventDefault();">
					<em class="fa fa-check"></em>
				</button>
			</div>
			<div class="font-mont-semi-bold form-step-number">1</div>
			<div class="form-step-title">
				<h1 class="font-mont-semi-bold">Business Information</h1>
			</div>
		</div>
		<form [formGroup]="businessInfo.form" (ngSubmit)="onContinueClick()" *ngIf="businessInfo">
			<!-- Business Info -->
			<div class="business-info-section clearfix">
				<div class="form-row">
					<div class="form-group col-sm-6">
						<label for="legalCompanyName"
							[ngClass]="{ 'color-red': submitted && bForm.legalCompanyName.errors }">Business Name: *
							<div class="information-icon">
								<i class="fa fa-info-circle" aria-hidden="true"></i>
								<div class="tool-tip-container">
									<div class="tip-text">
										<span>This is your business’s official name</span>
										<span>on legal paperwork.</span>
									</div>
								</div>
							</div>
						</label>
						<input type="text" formControlName="legalCompanyName" class="form-control" id="legalCompanyName"
							name="legalCompanyName"
							[ngClass]="{ 'is-invalid': submitted && bForm.legalCompanyName.errors }">
						<div *ngIf="submitted && bForm.legalCompanyName.errors" class="invalid-feedback">
							<div *ngIf="bForm.legalCompanyName.errors.required">
								Business Name is required.
							</div>
						</div>
					</div>
					<div class="form-group col-sm-6 bsDatepicker">

						<label for="businessStartDate"
							[ngClass]="{ 'color-red': submitted && bForm.businessStartDate.errors }">Business Start
							Date:
							*</label>
						<input placeholder="mm/yyyy" type="text" formControlName="businessStartDate"
							class="form-control" id="businessStartDate" name="businessStartDate"
							[ngClass]="{ 'is-invalid': submitted && bForm.businessStartDate.errors }" bsDatepicker
							[bsConfig]="{ dateInputFormat: 'MM/YYYY', isAnimated: true, containerClass: 'theme-dark-blue', minMode: 'month'}"
							[maxDate]="today" [minDate]="minDate">
						<div *ngIf="submitted && bForm.businessStartDate.errors" class="invalid-feedback">
							<div *ngIf="bForm.businessStartDate.errors.required">
								Business Start Date is required.
							</div>
						</div>

					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-sm-6">
						<label for="doingBusinessAs"
							[ngClass]="{ 'color-red': submitted && bForm.doingBusinessAs.errors }">Doing Business As
							(DBA): *
							<div class="information-icon">
								<i class="fa fa-info-circle" aria-hidden="true"></i>
								<div class="tool-tip-container">
									<div class="tip-text">
										<span>This is what you call your business every day (it </span>
										<span>may be the same as your Business Name).</span>
									</div>
								</div>
							</div>
						</label>
						<input type="text" formControlName="doingBusinessAs" class="form-control" id="doingBusinessAs"
							name="doingBusinessAs"
							[ngClass]="{ 'is-invalid': submitted && bForm.doingBusinessAs.errors }">
						<div *ngIf="submitted && bForm.doingBusinessAs.errors" class="invalid-feedback">
							<div *ngIf="bForm.doingBusinessAs.errors.required">
								DBA is required.
							</div>
						</div>
					</div>
					<div class="form-group col-sm-6">
						<label for="primaryContactEmail" class="font-mont-book"
							[ngClass]="{ 'color-red': submitted && bForm.primaryContactEmail.errors }">Email Address:
							*</label>
						<input type="email" formControlName="primaryContactEmail" class="form-control"
							id="primaryContactEmail" name="primaryContactEmail"
							[ngClass]="{ 'is-invalid': submitted && bForm.primaryContactEmail.errors }">
						<div *ngIf="submitted && bForm.primaryContactEmail.errors" class="invalid-feedback">
							<div *ngIf="bForm.primaryContactEmail.errors.required">
								Email Address is required.
							</div>
							<div *ngIf="bForm.primaryContactEmail.errors.email">
								Invalid email address.
							</div>
						</div>
					</div>
				</div>
				<div class="form-row">
					<div class="form-group col-sm-6">
						<label for="businessAddress"
							[ngClass]="{ 'color-red': submitted && bForm.businessAddress.errors }">Business Street
							Address:
							*</label>
						<input type="text" formControlName="businessAddress" class="form-control" id="businessAddress"
							name="businessAddress"
							[ngClass]="{ 'is-invalid': submitted && bForm.businessAddress.errors }">
						<div *ngIf="submitted && bForm.businessAddress.errors" class="invalid-feedback">
							<div *ngIf="bForm.businessAddress.errors.required">
								Business Street Address is required.
							</div>
						</div>
					</div>
					<div class="form-group col-sm-6">
						<label for="zip" [ngClass]="{ 'color-red': submitted && bForm.zip.errors }">Zip: *</label>
						<input type="text" formControlName="zip" class="form-control" id="zip" name="zip"
							(keyup)="onZipCodeKeyUpHandler()" maxlength="5" pattern="\d*"
							[ngClass]="{ 'is-invalid': submitted && bForm.zip.errors }">
						<div *ngIf="submitted && bForm.zip.errors" class="invalid-feedback">
							<div *ngIf="bForm.zip.errors.required">
								Zip is required.
							</div>
						</div>
					</div>
				</div>
				<div class="form-row">

					<div class="form-group col-sm-6 select">
						<label for="city" [ngClass]="{ 'color-red': submitted && bForm.city.errors }">City: *</label>
						<select formControlName="city" class="form-control" id="city"
							[ngClass]="{ 'is-invalid': submitted && bForm.city.errors }">
							<option *ngFor="let city of cities" [ngValue]="city">{{city}}</option>
						</select>
						<div *ngIf="submitted && bForm.city.errors" class="invalid-feedback">
							<div *ngIf="bForm.city.errors.required">
								City is required.
							</div>
						</div>
					</div>
					<div class="form-group col-sm-2 select">
						<label for="state" [ngClass]="{ 'color-red': submitted && bForm.state.errors }">State: *</label>
						<select formControlName="state" class="form-control" id="state"
							[ngClass]="{ 'is-invalid': submitted && bForm.state.errors }" [attr.disabled]="true">
							<option *ngFor="let state of states" [ngValue]="state.code">
								{{state.name}}</option>
						</select>
						<div *ngIf="submitted && bForm.state.errors" class="invalid-feedback">
							<div *ngIf="bForm.state.errors.required">
								State is required.
							</div>
						</div>
					</div>
					<div class="form-group col-sm-4 select">
						<label for="county" [ngClass]="{ 'color-red': submitted && bForm.county.errors }">County:
							*</label>
						<select formControlName="county" class="form-control" id="county"
							[ngClass]="{ 'is-invalid': submitted && bForm.county.errors }">
							<option *ngFor="let county of counties" [ngValue]="county">{{county}}</option>
						</select>
						<div *ngIf="submitted && bForm.county.errors" class="invalid-feedback">
							<div *ngIf="bForm.county.errors.required">
								County is required.
							</div>
						</div>
					</div>

				</div>
				<div *ngIf='!userPOS' class="business-info-section clearfix">
					<div class="form-row">
						<div class="form-group col-md-12">
							<label for="requestedAmount"
								[ngClass]="{ 'color-red': submitted && bForm.requestedAmount.errors }">Requested Amount:
								*</label>
							<input type="text" formControlName="requestedAmount" class="form-control"
								id="requestedAmount" placeholder="$ " name="requestedAmount" prefix="$ "
								mask="separator.2" thousandSeparator=","
								[ngClass]="{ 'is-invalid': submitted && bForm.requestedAmount.errors }">
							<div *ngIf="submitted && bForm.requestedAmount.errors" class="invalid-feedback">
								<div *ngIf="bForm.requestedAmount.errors.required">
									Requested Amount is required.
								</div>
								<div *ngIf="bForm.requestedAmount.errors.max">
									Your max requested amount is {{maxApplicationAmount | currency:'$ ':'code':'.0-0'}}.
								</div>
								<div *ngIf="bForm.requestedAmount.errors.min">
									Your minimum requested amount is {{500 | currency:'$ ':'code':'.0-0'}}.
								</div>
							</div>
						</div>
					</div>
					<div class="form-row">
						<div class="form-group col-md-12">
							<label for="equipmentDescription"
								[ngClass]="{ 'color-red': submitted && bForm.equipmentDescription.errors }">Equipment
								Description:</label>
							<textarea formControlName="equipmentDescription" class="form-control"
								id="equipmentDescription" rows="4" name="equipmentDescription"
								[ngClass]="{ 'is-invalid': submitted && bForm.equipmentDescription.errors }"></textarea>
							<div *ngIf="submitted && bForm.equipmentDescription.errors" class="invalid-feedback">
								<div *ngIf="bForm.equipmentDescription.errors.required">
									Equipment Description is required.
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="form-row display-block clearfix footer-buttons-container">
				<div class="form-group">
					<button type="submit" class="btn btn-primary btn-lg col-md-12" [disabled]="buttonContinueDisabled">
						Next
					</button>
				</div>
				<div *ngIf='!userPOS' class="form-group">
					<button type="submit" class="btn btn-secondary btn-lg col-md-12"
						(click)="onBackClick();">Back</button>
				</div>
			</div>
		</form>
	</div>
	<app-what-makes-us-different></app-what-makes-us-different>
</div>